//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
const queryString = require('query-string');

export default {
  data: function () {
    //console.log('Host ip: ' + location.host)
    var defaultHost = 'http://localhost:9000'
    if (process.env.NODE_ENV === "development") {
      console.log('Running GSTS client in development mode')
    }
    else {
      console.log('Running GSTS client in production mode')
      defaultHost = '/api';
    }
    return {
      url: defaultHost
    }
  },
  computed: {
    ...mapState({
      serverDialog: state => state.preferences.global.serverDialog
    })
  },
  methods: {
    onOK: function () {
      this.closeDialog()
      this.$emit('update-server-url', this.url)
    },
    closeDialog: function () {
      this.$store.commit("preferences/updateServerDialog", false);
    }
  }
}
